import type { SVGProps } from "react";
import * as React from "react";

const SvgDivideSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 11a1 1 0 1 0 0 2zm8 2a1 1 0 1 0 0-2zM5 4h14V2H5zm14 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v14h2V5zm0 14a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H5v2h14zM5 20a1 1 0 0 1-1-1H2a3 3 0 0 0 3 3zm-1-1V5H2v14zM4 5a1 1 0 0 1 1-1V2a3 3 0 0 0-3 3zm4 8h8v-2H8z"
    />
  </svg>
);
export default SvgDivideSquare;
